<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Warehouse Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-warehouse-name">Warehouse Name</label>
                <input type="text" class="form-control" id="btk-warehouse-name" v-model="warehouse.name">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-warehouse-address">Address</label>
                <input type="text" class="form-control" id="btk-warehouse-address" v-model="warehouse.address">
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="btk-warehouse-is-active">Active</label>
                <input type="checkbox" class="form-control" v-model="warehouse.isActive" id="btk-warehouse-is-active">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { warehouse } from '../../models/warehouse'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
      AppLookupField, AppDatePicker, AppNavBar
    },
    data() {
      return {
        warehouse: {...warehouse},
      }
    },
    async created() {
      if(this.$route.query.id !== undefined) {
        const warehouseApi = api('warehouse')
        this.warehouse = await warehouseApi.getWithParams(this.$route.query.id)
      }
    },
    methods: {
      async save() {
        const warehouseApi = api('warehouse')
        if(this.$route.query.id !== undefined) {
          await warehouseApi.update(this.warehouse, this.$route.query.id)
        } else {
          await warehouseApi.create(this.warehouse)
        }
        this.$router.go(-1)
      },
      cancel() {
        this.$router.go(-1)
      },
      finishLookup(data) {
        const currentWarehouse = this.warehouse
        this.warehouse = {
          ...currentWarehouse,
          ...data
        }
      } 
    }
}
</script>